// Team/Team.jsx 
import React from 'react';
import './Team.css';
import { useLanguage } from '../../context/LanguageContext';
import teamPhoto from '../../images/team/teamphoto.jpg';
import teamPhoto2026 from '../../images/team/foto2026.jpg';

// Ícones das redes
import githubIcon from '../../images/icons/github.png';
import lattesIcon from '../../images/icons/lattes.png';
import linkedinIcon from '../../images/icons/linkedin.webp';

// Fotos das pessoas
import marcusPhoto from '../../images/team/people/Marcus-Scotti.png';
import thaisPhoto from '../../images/team/people/Thais.webp';   
import tulioPhoto from '../../images/team/people/TulioSilvestre.jpeg';
import alanPhoto from '../../images/team/people/alan.jpg'; 
import uilamesPhoto from '../../images/team/people/Uilames.jpg';
import eduardoPhoto from '../../images/team/people/eduardo.jpg';
import lucianoPhoto from '../../images/team/people/Luciano.png';
import lucianaPhoto from '../../images/team/people/luciana.jpeg';
import renanPhoto from '../../images/team/people/Renan.jpeg';
import ciroPhoto from '../../images/team/people/ciro.jpeg';
import adielPhoto from '../../images/team/people/adiel.jpg';
import renataPhoto from '../../images/team/people/renata.jpg';
import nataliaPhoto from '../../images/team/people/natalia.jpg';
import chonnyPhoto from '../../images/team/people/chonny.jpg';
import vitorPhoto from '../../images/team/people/Vitor.jpg';
import mayaraPhoto from '../../images/team/people/mayara.jpg';
import gabrielaPhoto from '../../images/team/people/gabriela.jpg';
import isadoraPhoto from '../../images/team/people/isadora.jpg';
import andrezaPhoto from '../../images/team/people/andreza.jpg';
import mayaraBarbalhoPhoto from '../../images/team/people/mayarabarbalho.jpg';
import elidaPhoto from '../../images/team/people/elida.jpg';
import alixandrePhoto from '../../images/team/people/alixandre.jpg';
import brendoPhoto from '../../images/team/people/brendo.jpg';
import luisfPhoto from '../../images/team/people/luisf.png';

// Ícone para o título "Lab Members"
import teamIcon from '../../images/icons/team.png';

/**.
 * Cada "pessoa" tem: name, description, photo, github, lattes, linkedin.
 * Se github (por exemplo) for null, significa que não há link.
 */
const currentMembers = [
  {
    name: 'Marcus Tullius Scotti',
    description:
      'Engenheiro Químico pela USP (1999), com pós-graduação em Administração Industrial (USP), Mestrado (2005) e Doutorado (2008) em Química Orgânica pelo Instituto de Química da USP. Atualmente, é Professor Associado 4 no Departamento de Química da UFPB, atuando nas áreas de Química de Produtos Naturais, Quimioinformática, QSAR, e triagem virtual. É docente permanente do Programa de Pós-Graduação em Produtos Naturais e Sintéticos Bioativos e foi tesoureiro da Divisão de Produtos Naturais da Sociedade Brasileira de Química',
    photo: marcusPhoto,
    github: null, // não tem
    lattes: 'http://lattes.cnpq.br/9312500923026323',
    linkedin: 'https://www.linkedin.com/in/marcus-scotti-2434b09',
  },
  {
    name: 'Luciana Scotti',
    description:
      'Graduada em Farmácia-Bioquímica pela USP (1994). Concluiu Mestrado (2002) e Doutorado (2006) em Cosmetologia e Modelagem Molecular na USP, seguido de três pós-doutorados (2007 - 2013) em Fármaco-Medicamentos (USP), Produtos Naturais e Sintéticos Bioativos (UFPB) e Antibióticos (UFPE). Atualmente é farmacêutica do HULW, docente voluntária do Programa de Pós-Graduação em Produtos Naturais e Sintéticos Bioativos da UFPB, e detentora da Comenda do Mérito Farmacêutico.',
    photo: lucianaPhoto,
    github: null, // não tem
    lattes: 'http://lattes.cnpq.br/6420461345651715',
    linkedin: 'https://br.linkedin.com/in/luciana-scotti-588242a2',
  },
  {
    name: 'Thais de Andrade Lourenço',
    description:
      'Graduada em Ciências Biomédicas pela Universidade de Aveiro (2022), com ênfase em Biomedicina Molecular. Em 2022, iniciou estudos em Bioinformática na Universidade de Aveiro e complementou sua formação na Ècole 42 (2023) com cursos em Engenharia Computacional e Estatística aplicadas à saúde. Atualmente, é pós-graduanda em Farmácia (Fisiopatologia e Toxicologia) na FCF/USP e integra o Laboratório de Inteligência e Tecnologias Educacionais em Computação da USP (2024).',
    photo: thaisPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/8860958820353410',
    linkedin: 'https://www.linkedin.com/in/thaislour/',
  },
  {
    name: 'Túlio Silvestre Nobre',
    description:
      'Professor de Química. Bacharel em Química Industrial pela UFPB e Mestre em Química Orgânica no Programa de Pós-graduação em Química (PPGQ - UFPB)',
    photo: tulioPhoto,
    github: null,
    lattes: 'https://lattes.cnpq.br/1080383632543507',
    linkedin: 'https://www.linkedin.com/in/tulio-silvestre-404a33bb',
  },
  {
    name: 'Alan Ferreira Alves',
    description:
      'Farmacêutico pela UFPB. Possui experiência no desenvolvimento de jogos sérios com foco em Realidade Aumentada e na área de psicofarmacologia.. Atualmente, é mestrando do PPGPNSB/UFPB, atuando na área de Quimioinformática.',
    photo: alanPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/7557510062163879',
    linkedin: null, // não tem
  },
  {
    name: 'Adiel Henrique Pontes',
    description:
      'Licenciado em Química pelo IFPB. Mestrando em Química pela UFPB, trabalha atualmente com Quimioinformática aplicada ao desenvolvimento de fármacos.',
    photo: adielPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/6574950105082550',
    linkedin: null, // não tem
  },
  {
    name: 'Renata Menezes',
    description:
      'Farmacêutica com graduação pela UEPB e Mestrado-Doutorado em Produtos Naturais e Sintéticos Bioativos (UFPB), incluindo pós-doutorado na área. Especialista em química medicinal, seu trabalho foca no desenvolvimento de fármacos, utilizando modelos preditivos e ferramentas computacionais avançadas para explorar alvos biológicos e otimizar propriedades farmacológicas.',
    photo: renataPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/9512045991145654',
    linkedin: 'http://www.linkedin.com/in/renata-menezes-906b33152', 
  },
  {
    name: 'Natália Ferreira de Sousa',
    description:
      'Farmacêutica pela UFCG, especialista em Saúde Mental (UFS) e Informática em Saúde (UFRN), mestre e doutoranda em Farmacoquímica (UFPB), com período sanduíche na UNIBA/Itália. Atua em quimioinformática, modelagem molecular de fármacos e QSAR, com experiência em saúde pública, farmacoterapia e química analítica.',
    photo: nataliaPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/4129217118316011',
    linkedin: 'https://www.linkedin.com/in/nat%C3%A1lia-ferreira-de-sousa-31131420a/', 
  },

  {
    name: 'Brendo Araujo Gomes',
    description:
      'Graduado em Ciências Biológicas (Licenciatura) pela Universidade Federal do Estado do Rio de Janeiro (Unirio) e mestre em Biotecnologia Vegetal e Bioprocessos pela Universidade Federal do Rio de Janeiro (UFRJ). Atualmente, é doutorando no Laboratório de Fitoquímica e Farmacognosia (FitoFar) da UFRJ',
    photo: brendoPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/4129217118316011',
    linkedin: 'https://www.linkedin.com/in/nat%C3%A1lia-ferreira-de-sousa-31131420a/', 
  },
  {
    name: 'Luis Felipe',
    description:
      '----',
    
    photo: luisfPhoto,
    github: null,
    lattes: null,
    linkedin: null,
  },

];

const collaborators = [
  {
    name: 'Uilames de Assis',
    description: 'Estagiário em Engenharia de Dados na Petlove. Pesquisador e desenvolvedor na IPeFarM/UFPB. Possui experiência em desenvolvimento backend (Django, React, Nest, Java/Spring Boot) e em pesquisas aplicando Machine Learning.',
    photo: uilamesPhoto,
    github: 'https://github.com/uilames',
    lattes: 'http://lattes.cnpq.br/8115428346736686',
    linkedin: 'https://www.linkedin.com/in/uilames-de-assis-89320818a/',
  },
  {
    name: 'Eduardo Henrique Pessoa Alves',
    description:
      'Graduando em Ciência de Dados e Inteligência Artificial, Pesquisador e atuando como desenvolvedor back-end com Python, Java e TypeScript. Possui experiência em machine learning com Scikit-learn, TensorFlow, Keras e PyTorch.',
    
    photo: eduardoPhoto, 
    github: 'https://github.com/henriqubjj',
    lattes: 'http://lattes.cnpq.br/7083876932417252',
    linkedin: 'https://www.linkedin.com/in/henriquebjj/',
  },
  {
    name: 'Luciano Pereira de Oliveira Filho',
    description:
      'Graduando em Ciência da Computação, Pesquisador e atuando como desenvolvedor front-end com Javascript, React, Node.js e TypeScript. Possui experiência em desenvolvimento de aplicações web',
    
    photo: lucianoPhoto, 
    github: 'https://github.com/luci18530',
    lattes: 'http://lattes.cnpq.br/7560473186881972',
    linkedin: 'https://www.linkedin.com/in/lucipere/',
  },
  {
    name: 'Ciro Gomes',
    description:
      'Técnico em Informática, cursa a graduação em Ciência de Dados e Inteligência Artificial pela Universidade Federal da Paraíba (UFPB). Atua na Shopinfo, onde desenvolve aplicações web, além de possuir experiência em análise de dados e visualização, utilizando ferramentas como Tableau e Python.',
    
    photo: ciroPhoto,
    github: 'https://github.com/CiroGomess',
    lattes: null,
    linkedin: 'https://www.linkedin.com/in/ciro-gomes/',
  },
  {
    name: 'Renan Costa',
    description:
      'Graduado em Ciência da Computação pelo Centro Universitário de João Pessoa (2020) e em Tecnologia em Gastronomia pela Faculdade Internacional da Paraíba (2018). Atualmente, é desenvolvedor pleno na FUZE Tecnologia e mestrando em Inteligência Artificial pelo Programa de Pós-Graduação em Informática da UFPB. FullStack, AI and Android Developer.',
    
    photo: renanPhoto,
    github: 'https://github.com/RenanCostaSource',
    lattes: 'http://lattes.cnpq.br/6541767437032885',
    linkedin: 'https://www.linkedin.com/in/renan-paiva-2b651279/',
  },
  
];

const alumni = [
  {
    name: 'Chonny Herrera-Acevedo',
    description:
      'Professor assistente na Universidade ECCI, em Bogotá, Colômbia. Químico (Universidad Nacional de Colombia, 2012), Mestre (2017) e Doutor em Produtos Naturais e Sintéticos Bioativos (Universidade Federal da Paraíba, 2024), com expertise em descoberta de fármacos e desenvolvimento de produtos naturais. Possui sólida formação em química computacional, utilizando ferramentas de Quimioinformática e Modelagem Molecular para acelerar o processo de descoberta de novas moléculas com potencial terapêutico.',
    photo: chonnyPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/3448450793159480',
    linkedin: 'https://co.linkedin.com/in/chonny-herrera-acevedo-69b61a132',
  },
  {
    name: 'Vitor Prates Lorenzo',
    description:
      'Graduado em Farmácia pela Universidade Federal da Paraíba (2007), com mestrado e doutorado em Produtos Naturais e Sintéticos Bioativos pela mesma instituição (2010). Atualmente, é professor efetivo no Instituto Federal do Sertão Pernambucano (IFSertãoPE) e Pró-Reitor de Extensão e Cultura desde 2020. Tem experiência em Farmácia, com foco em Química de Produtos Naturais, Fitoquímica, Quimioinformática, Modelagem Molecular, Predição de Atividade e Docking Molecular.',
    photo: vitorPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/8662106174130168',
    linkedin: 'https://www.linkedin.com/in/vitor-prates-lorenzo-083568232',
  },
  {
    name: 'Mayara dos Santos Maia',
    description:
      'Graduada em Ciências Biológicas pela Universidade Federal da Paraíba (2015) e Mestre em Biologia Celular e Molecular (UFPB, 2017), com atuação em Genética, Oncogenética, Biologia Molecular e técnicas como PCR-Real Time. Doutora em Produtos Naturais e Sintéticos Bioativos (UFPB, 2021). Realizou pós-doutorado no Laboratório de Genética Evolutiva Paulo Leminski (UFPB, 2024). Possui experiência em Quimioinformática, Bioinformática, Triagem Virtual, Modelagem e Docking Molecular',
    photo: mayaraPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/6199480328917320',
    linkedin: null,
  },
  {
    name: 'Gabriela Cristina Soares Rodrigues',
    description:
      'Graduada em Bacharelado em Ecologia pela Universidade Federal da Paraíba (UFPB, 2012), mestre em Engenharia Civil e Ambiental (UFPB, 2015), licenciada em Biologia (Universidade Cruzeiro do Sul, 2020) e doutora em Produtos Naturais e Sintéticos Bioativos (UFPB, 2021). Tem experiência em Planejamento Ambiental, Química Orgânica, Química Ambiental, Análise Físico-Química da Água, Recuperação de Nascentes, Química de Produtos Naturais, Quimioinformática, QSAR e Descritores Moleculares.',
    photo: gabrielaPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/9737040203830196',
    linkedin: null,
  },
  {
    name: 'Isadora Silva Luna',
    description:
      'Doutoranda em Produtos Naturais e Sintéticos Bioativos (Farmacoquímica) pela Universidade Federal da Paraíba (UFPB), com mestrado no mesmo programa. Bacharel em Ciências Biológicas pela Universidade Estadual da Paraíba (UEPB). Atuou no laboratório de síntese e vetorização de moléculas (UEPB). Desenvolve pesquisas em Química Medicinal, com ênfase em Triagem Virtual, Machine Learning, Molecular Docking, Relações Quantitativas Estrutura-Atividade (QSAR) e Síntese Orgânica.',
    photo: isadoraPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/1632573001902586',
    linkedin: null,
  },
  {
    name: 'Mayara Barbalho Félix',
    description:
      'Graduada em Ciências Biológicas (Bacharelado) pela UEPB e em Licenciatura em Ciências Biológicas pela UNAVIDA. Mestre pelo Programa de Pós-Graduação em Biologia Celular e Molecular (DBM - UFPB) e doutora pelo Programa de Pós-Graduação em Produtos Naturais e Sintéticos Bioativos (UFPB). Atua na área de descoberta de novos fármacos derivados de 2-amino tiofenos para o tratamento das leishmanioses, com experiência em síntese, estudos in silico e avaliação biológica.',
    photo: mayaraBarbalhoPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/7713508549424920',
    linkedin: null,
  },

  {
    name: 'Élida Batista Vieira Cavalcanti',
    description:
      'Farmacêutica Bioquímica graduada pela Universidade Federal da Paraíba (UFPB), com mestrado e doutorado em Produtos Naturais e Sintéticos Bioativos (área de Farmacoquímica) pela mesma instituição. Tem experiência em Farmácia Comunitária e Produtos Naturais. Atua como professora nos cursos de Farmácia, Medicina, Fisioterapia, Odontologia, Enfermagem e Educação Física. Desenvolve projetos acadêmicos voltados para Fitoterapia e Psicofármacos, além de orientar trabalhos na área de Farmácia.',
    photo: elidaPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/0505119273769528',
    linkedin: null,
  },

  {
    name: 'José Alixandre de Sousa Luis',
    description:
      'Graduado em Farmácia pela Universidade Federal da Paraíba (UFPB, 2000), com habilitação em Análises Clínicas, e mestre (2003) e doutor (2007) em Produtos Naturais e Sintéticos Bioativos pela mesma instituição. Realizou pós-doutorado em Quimioinformática na UFPB (2017-2019). Atualmente, é Professor Titular na Universidade Federal de Campina Grande (UFCG). Tem experiência em pesquisa na área de desenvolvimento de novos fármacos, com foco em atividade antimicrobiana.',
    photo: alixandrePhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/0505119273769528',
    linkedin: null,
  },
  
  {
    name: 'Andreza Barbosa Silva Cavalcanti',
    description:
      'Graduada em Farmácia pela Universidade Federal da Paraíba (2013), com mestrado (2016) e doutorado (2021) em Produtos Naturais e Sintéticos Bioativos pela mesma instituição. Atualmente, é professora na Universidade Paulista (UNIP), tutora EAD na Ivy Enber Christian University e farmacêutica na Secretaria Municipal de Saúde de João Pessoa.',
    photo: andrezaPhoto,
    github: null,
    lattes: 'http://lattes.cnpq.br/6843738320463098',
    linkedin: null,
  },
  
  
];

function Team() {
  const { t } = useLanguage();

  // Função que rola até uma determinada seção
  const handleScrollTo = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Renderiza o card de uma pessoa real
  const renderPersonCard = (person, index) => {
    return (
      <div className="member-card" key={index}>
        <img src={person.photo} alt={person.name} className="member-photo" />
        <div className="member-info">
          <div className="member-name">{person.name}</div>
          <div className="member-description">{person.description}</div>
          <div className="member-socials">
            {/* GitHub */}
            <a
              href={person.github ? person.github : '#'}
              className="social-button"
              style={{ backgroundColor: person.github ? '#4171CC' : '#fafafa' }}
              target={person.github ? '_blank' : '_self'}
              rel="noreferrer"
            >
              <img src={githubIcon} alt="GitHub" />
            </a>

            {/* Lattes */}
            <a
              href={person.lattes ? person.lattes : '#'}
              className="social-button"
              style={{ backgroundColor: person.lattes ? '#4171CC' : '#fafafa' }}
              target={person.lattes ? '_blank' : '_self'}
              rel="noreferrer"
            >
              <img src={lattesIcon} alt="Lattes" />
            </a>

            {/* LinkedIn */}
            <a
              href={person.linkedin ? person.linkedin : '#'}
              className="social-button"
              style={{ backgroundColor: person.linkedin ? '#4171CC' : '#fafafa' }}
              target={person.linkedin ? '_blank' : '_self'}
              rel="noreferrer"
            >
              <img src={linkedinIcon} alt="LinkedIn" />
            </a>
          </div>
        </div>
      </div>
    );
  };

  return (
    <main className="team-container">
      {/* Título da página */}
      <h1 className="team-title">
        {t('teamLabMembersTitle')}
        <img src={teamIcon} alt="Team" className="title-icon" />
      </h1>

      {/* Botões horizontais */}
      <div className="team-buttons">
        <button onClick={() => handleScrollTo('current-members')}>
          {t('teamCurrentMembersBtn')}
        </button>
        <button onClick={() => handleScrollTo('collaborators')}>
          {t('teamCollaboratorsBtn')}
        </button>
        <button onClick={() => handleScrollTo('alumni')}>
          {t('teamAlumniBtn')}
        </button>
      </div>

      {/* Seção Current Members */}
      <section id="current-members" className="team-section">
        <h2 className="team-subtitle">{t('teamCurrentMembersTitle')}</h2>
        <div className="team-text">
          {t('teamCurrentMembersText')}
        </div>

        {/* Renderizamos os membros reais em cards (4 por linha, por ex.) */}
        <div className="members-grid">
          {currentMembers.map((person, idx) => renderPersonCard(person, idx))}
        </div>
      </section>

      {/* Seção Collaborators */}
      <section id="collaborators" className="team-section">
        <h2 className="team-subtitle">{t('teamCollaboratorsTitle')}</h2>
        <div className="team-text">
          {t('teamCollaboratorsText')}
        </div>

        {/* Colaboradores reais (aqui, apenas 1) */}
        <div className="members-grid">
          {collaborators.map((person, idx) => renderPersonCard(person, idx))}
        </div>
      </section>

      {/* Seção Alumni */}
      <section id="alumni" className="team-section">
        <h2 className="team-subtitle">{t('teamAlumniTitle')}</h2>
        <div className="team-text">{t('teamAlumniText')}</div>
        <div className="members-grid">
          {alumni.map((person, idx) => renderPersonCard(person, idx))}
        </div>
      </section>

      {/* Foto do time (900x450) */}
      <div className="team-photo-container">
        <img
          src={teamPhoto}
          alt="Team Photo"
          className="team-photo"
        />
        <img
          src={teamPhoto2026}
          alt="Team Photo 2026"
          className="team-photo"
        />
      </div>
    </main>
  );
}

export default Team;
